// Components
import Preloader from "components/molecules/Preloader";

// Hooks
import { useInitLandingLoading } from "hooks/useInitLandingLoading";

// Selectors
import { useSettingsStore } from "stores/settings";

const PreloaderLandingContainer = () => {
  const { progress, total } = useInitLandingLoading();
  const serviceErrorState = useSettingsStore((state) => state.serviceError);

  if (serviceErrorState) {
    return null;
  }
  return <Preloader progress={(progress / total) * 100} closeTime={400} />;
};

export default PreloaderLandingContainer;
